import React, { FC } from 'react';
import BusyModeModal from 'components/Modals/BusyModeModal';
import { Props } from './types';
import {
  Row,
  RightSectionBorder,
  Avatar,
  IntegrationName,
  Switch,
  BusyModeInfo,
  BusyCaption,
  AlarmIcon,
  BusyUntil,
} from './styles';
import useConnect from './connect';

const IntegrationStatus: FC<Props> = ({ integration, brandId }) => {
  const {
    handleChangeStatus,
    showBusyModeModal,
    setShowBusyModeModal,
    updateState,
    busyUntil,
  } = useConnect({
    brandId,
    integration,
    isChecked: integration.isActive,
  });

  return (
    <>
      <Row>
        <Avatar src={integration.image.src} alt={integration.image.alt} />
        <RightSectionBorder>
          <IntegrationName>{integration.name.full}</IntegrationName>
          {integration.isActive ? 'Online' : 'Offline'}
          <Switch
            checked={integration.isActive}
            // disabled={integration.disabled || isLoading}
            onChange={handleChangeStatus}
          />
          {showBusyModeModal && (
            <BusyModeModal
              brandId={brandId}
              integrationId={integration.id}
              open
              handleClose={(submitted) => {
                if (submitted) {
                  updateState(brandId, integration.id).then();
                }
                setShowBusyModeModal(false);
              }}
            />
          )}
        </RightSectionBorder>
      </Row>
      {!integration.isActive && (
        <Row>
          <BusyModeInfo>
            <BusyUntil>
              <AlarmIcon />
              {busyUntil}
            </BusyUntil>
            <BusyCaption>
              This channel is currently not accepting any orders as it is under
              busy mode
            </BusyCaption>
          </BusyModeInfo>
        </Row>
      )}
    </>
  );
};

export default IntegrationStatus;

// TODO: TFR-44 move to status group
